import React from "react";
import { assetsPrefix } from "../../utilities/utilities";

const SOCIAL_ICONS = [
  "social-icons.svg",
  "social-icons-1.svg",
  "social-icons-2.svg",
  "social-icons-3.svg",
];

const Footer = () => (
  <footer className="mt-auto w-full border-t border-slate-200/80 bg-[#F8FDFF] backdrop-blur-sm">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-4 py-8 md:flex-row md:px-8 md:py-10">
      <img
        src={`${assetsPrefix}/images/trueCounselLogo.png`}
        alt="TrueCounsel"
        className="h-8 w-auto object-contain md:h-9"
      />

      <p className="text-center text-sm text-slate-500">
        © {new Date().getFullYear()} TrueCounsel. All rights reserved.
      </p>

      <div className="flex items-center gap-3">
        {SOCIAL_ICONS.map((icon) => (
          <img
            key={icon}
            src={`${assetsPrefix}/images/social-icons/${icon}`}
            alt=""
            className="size-8 opacity-60 rounded-lg transition-opacity hover:opacity-100"
          />
        ))}
      </div>
    </div>
  </footer>
);

export default Footer;
